import { IDetail } from '@app/entities/interfaces/anual-calendar/day.interface';
import { AccumulativeHours, StoreInfo } from '@app/entities/interfaces/mot/schedule.interface';

export class Schedule {
  months!: ScheduleMonth[];
  startMonday!: boolean;
}

export class ScheduleDay {
  date!: string;
  dayLabel!: string;
  dayName!: string;
  dayType!: ScheduleDayType | null;
  hasTasks!: boolean;
  detail!: IDetail[];
  selected?: boolean;
}

export class ScheduleDayType {
  ids!: string[];
  name!: string;
  primaryColour!: string;
  secondaryColour!: string;
  primaryShape!: string;
  secondaryShape!: string;
  isWorkingDay!: boolean;
}

export class ScheduleWeek {
  weekLabel!: string;
  weekNumber!: string;
  totalHours!: string;
  days!: ScheduleDay[];
}

export class ScheduleMonth {
  monthNumber!: string;
  monthLabel!: string;
  yearLabel!: string;
  weeks!: ScheduleWeek[];
}

export class ScheduleObservations {
  contract!: string;
  storeInfo!: StoreInfo[];
  monthHours!: AccumulativeHours;
  monthCaption!: string;
  accumulatedBalance!: AccumulativeHours;
  lastModified!: string;
  clause!: string;
  rotationGroup!: string;
}
